export default "__VITE_ASSET__DV72CvGP__"